import { Controller } from "@hotwired/stimulus"

// Filtra las opciones de un select según el valor de otro (Tema -> Subtema).
// Cada <option> del select dependiente declara data-parent-value con el id del
// padre al que pertenece.
//
// Las opciones que no corresponden se quitan del DOM en vez de ocultarse:
// Safari ignora el atributo `hidden` en <option>, así que ocultarlas dejaría
// opciones inválidas visibles.
export default class extends Controller {
  static targets = ["parent", "child"]
  static values = {
    emptyPrompt: { type: String, default: "Primero elige un tema" },
    prompt: { type: String, default: "Subtema" }
  }

  connect() {
    // Copia completa de las opciones, para poder reponerlas al cambiar de padre.
    this.allOptions = Array.from(this.childTarget.options).map((option) => option.cloneNode(true))
    this.blankOption = this.allOptions.find((option) => option.value === "")
    this.filter({ preserveSelection: true })
  }

  parentChanged() {
    this.filter()
  }

  filter({ preserveSelection = false } = {}) {
    const parentValue = this.parentTarget.value
    const previous = this.childTarget.value

    const matching = parentValue
      ? this.allOptions.filter((option) => option.dataset.parentValue === parentValue)
      : []

    this.childTarget.replaceChildren(...this.#blank(parentValue), ...matching.map((o) => o.cloneNode(true)))
    this.childTarget.disabled = parentValue === ""

    const keep = preserveSelection && matching.some((option) => option.value === previous)
    this.childTarget.value = keep ? previous : ""
  }

  #blank(parentValue) {
    if (!this.blankOption) return []

    const blank = this.blankOption.cloneNode(true)
    blank.textContent = parentValue ? this.promptValue : this.emptyPromptValue
    return [blank]
  }
}
